import type { Peer } from './peers';

// core가 meeting을 모르고 부르는 길 (v2 architecture-review 14장). 표는 core가 갖고, 채우는 일은 1-endpoints/modules.ts가 시작할 때 한 번 한다. 넣은 순서가 부르는 순서다.
export const HOOKS = {
  peerPose: [] as ((r: Peer) => boolean)[],   // 앉은 사람은 의자 위치·방향으로 놓는다(meeting). 놓았으면 true, 아니면 core가 받은 속도로 앞질러 그린다
};
